import { DataKiGraphParams } from '../dataKiGraph';
import { QueryParameter } from '../schemas';

export type TagAverageGraphDisplayFlags = {
  isKiTagAverageGraphDisplay?: boolean;
  isOnlyOneKiTagAverageGraphDisplay?: boolean;
  isExcludedKiTagAverageGraphDisplay?: boolean;
};

/**
 * 推移グラフ（店舗比較）の検索条件と表示フラグから、グラフを開いた行の QueryParameter を復元する。
 * お気に入り適用時に graphOpenedQueryParameter が未保存の旧データ向けフォールバックにも使う。
 */
export const buildGraphOpenedQueryParameter = (
  setting: DataKiGraphParams,
  flags: TagAverageGraphDisplayFlags = {}
): QueryParameter | undefined => {
  if (setting.isExcludeForTagIds === true) {
    return {
      name: '対象外機種平均合計',
      value: 'excludedKiTagAverage',
    };
  }

  const singleKiCode =
    setting.kiList?.length === 1 ? setting.kiList.at(0) : undefined;

  if (singleKiCode !== undefined) {
    return { name: 'kiList', value: singleKiCode };
  }

  if (flags.isKiTagAverageGraphDisplay === true) {
    return { name: 'タグ絞り込み平均合計', value: 'kiTagAverage' };
  }

  const tagId = setting.tagIds?.at(0);
  if (flags.isOnlyOneKiTagAverageGraphDisplay === true && tagId !== undefined) {
    return {
      name: '各機種タグ平均合計行',
      value: `onlyOneKiTagAverage_${tagId}`,
    };
  }

  if (flags.isExcludedKiTagAverageGraphDisplay === true) {
    return {
      name: '対象外機種平均合計',
      value: 'excludedKiTagAverage',
    };
  }

  if (setting.tagIds !== undefined && setting.tagIds.length > 1) {
    return { name: 'タグ絞り込み平均合計', value: 'kiTagAverage' };
  }

  if (tagId !== undefined && setting.tagIds?.length === 1) {
    return {
      name: '各機種タグ平均合計行',
      value: `onlyOneKiTagAverage_${tagId}`,
    };
  }

  return undefined;
};
